// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EventList_wrapper_13_vg"};